import { Page as ReactPDFPage } from '@react-pdf/renderer';

export const Page = ReactPDFPage;
